/**
 * Login callback component for Auth0 redirect.
 *
 * This component handles the callback from Auth0 after authentication.
 */

import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { Loader } from "@/ui/atoms";

export function LoginCallback() {
    const { isLoading, error, isAuthenticated } = useAuth0();
    const navigate = useNavigate();

    useEffect(() => {
        if (!isLoading && isAuthenticated) {
            // Auth0 SDK will handle the redirect via onRedirectCallback
            // This is just a fallback
            navigate("/", { replace: true });
        }
    }, [isLoading, isAuthenticated, navigate]);

    if (error) {
        return (
            <div className="flex h-screen flex-col items-center justify-center gap-4">
                <h1 className="text-2xl font-bold text-destructive">Authentication Error</h1>
                <p className="text-muted-foreground">{error.message}</p>
                <button onClick={() => navigate("/")} className="text-primary hover:underline">
                    Return to Home
                </button>
            </div>
        );
    }

    return (
        <div className="flex h-screen flex-col items-center justify-center gap-4">
            <Loader size="lg" />
            <p className="text-muted-foreground">Completing login...</p>
        </div>
    );
}
